import {createContext} from 'react';

const data = null;

export const PageDataContext = createContext(data);